import React from "react";
import { Typography } from "@mui/material";
import Header from "../../pages/Header";
import MenuBar from "../../pages/MenuBar";
import Footer from "../../pages/Footer";
import "./accessDenied.css";

export default function AccessDeniedPage() {
  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content" style={{ marginTop: "24px" }}>
          <div className="accessMainDiv">
            <div className="accessInnerDiv">
              <img
                src="/assets/accessDenied.svg"
                alt="access"
                className="accessImg"
              />
              <Typography
                className="headerH3Medium font-black-highest"
                style={{ marginBottom: "4px" }}
              >
                Access Denied
              </Typography>
              <Typography className="bodyB2RegularText font-black-high">
                You don’t have permission to access this page. Please contact
                your site administrator
              </Typography>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
